import ga4 from 'react-ga4';

import { GOOGLE_ANALYTICS_ID } from '@/env';
import { authStore } from '@/stores/auth';

export const init = () => GOOGLE_ANALYTICS_ID && ga4.initialize(GOOGLE_ANALYTICS_ID);

export const sendEvent = (action: string, category: string, label?: string) => {
  const currentUser = authStore.getState().currentUser;

  if (!currentUser?.isSupport) {
    ga4.event({
      category,
      action,
      ...(label && { label })
    });
  }
};
export const sendPageView = (path: string, title?: string) => {
  const currentUser = authStore.getState().currentUser;

  if (!currentUser?.isSupport) {
    ga4.send({
      hitType: 'pageview',
      page: path,
      ...(title && { title })
    });
  }
};
